import React from "react";
import { ViewerItemsVisibilityChangedEvent } from "./models/viewer-items-visibility-changed-event";

export interface ViewerItemsVisibilityContextProps {
    visibleItems: string[];

    initialiseVisibleItems: (items: string[]) => void,

    addItem: (item: string) => void,
    addItems: (items: string[]) => void,
    removeItem: (item: string) => void,
    removeItems: (items: string[]) => void,

    subscribeVisibilityChanged: (
        listener: (event: ViewerItemsVisibilityChangedEvent) => void
    ) => () => void;
}

export const ViewerItemsVisibilityContext = React.createContext<ViewerItemsVisibilityContextProps | undefined>(undefined);